import script from "./AdminPluginExpireManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPluginExpireManage.vue?vue&type=script&setup=true&lang=js"

import "./AdminPluginExpireManage.vue?vue&type=style&index=0&id=bb6515d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb6515d0"]])

export default __exports__